import { Dropdown, MenuItem } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";

const ClientActionButton = ({ availableActions, deleteClient }) => {
  return (
    <Dropdown
      pullRight
      id="client-actions-dropdown"
      className="dropdown-action-btn pull-right">
      <Dropdown.Toggle className="btn-wd btn-icon">
        <i className="fa fa-lg fa-check" />
        Action
      </Dropdown.Toggle>
      <Dropdown.Menu className="action-dropdown-menu">
        {availableActions.includes("DELETECLIENT") ? (
          <MenuItem
            onClick={() => {
              console.log("call deleteClient()");
              deleteClient();
            }}
            eventKey="1">
            <i className="fa fa-lg fa-trash" />

            <FormattedMessage id="ids_deleteClient" defaultMessage="Supprimer"/>
          </MenuItem>
        ) : (
          <div />
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ClientActionButton;
